<div class="map-content">
  <div id="pointMap"></div>
  <div class="closeDiv" (click)="closeModal()">
    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </div>
</div>

<div class="map-footer mobile-d-none">
  <div class="row">
    <div class="col-12" *ngIf="!editPos">
      <button *ngIf="!isReadOnly" class="btn btn-nc btn btn-primary me-2" type="button" (click)="editPosition()">
        <fa-icon [icon]="['fas', 'edit']"></fa-icon>
        &nbsp;{{'button.action.edit.label'|translate}}
      </button>

      <button type="button" (click)="closeModal()" class="btn btn-nc btn-secondary me-2">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>&nbsp;
        <span>{{ 'button.action.cancel.label' | translate }}</span>
      </button>
    </div>

    <div class="col-12" *ngIf="editPos">
      <button type="button" (click)="cancelEdition()" class="btn btn-nc btn-secondary me-2">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>&nbsp;
        <span>{{ 'button.action.cancel.label' | translate }}</span>
      </button>
      <button type="button" (click)="savePos()" class="btn btn-nc btn-info me-2">
        <fa-icon [icon]="['fas', 'save']"></fa-icon>&nbsp;
        <span>{{ 'button.action.valid.label' | translate }}</span>
      </button>
    </div>

  </div>

</div>

<div class="map-footer desktop-d-none">
  <div class="row">
    <div class="col-12" *ngIf="!editPos">
      <button class="btn btn-nc btn btn-primary mr-2" type="button" (click)="editPosition()">
        <fa-icon [icon]="['fas', 'edit']"></fa-icon>
      </button>

      <button type="button" (click)="closeModal()" class="btn btn-nc btn-secondary mr-2">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>
      </button>
    </div>

    <div class="col-12" *ngIf="editPos">
      <button type="button" (click)="cancelEdition()" class="btn btn-nc btn-secondary mr-2">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>
      </button>
      <button type="button" (click)="savePos()" class="btn btn-nc btn-info mr-1">
        <fa-icon [icon]="['fas', 'save']"></fa-icon>
      </button>
    </div>

  </div>

</div>